import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { avatarItemsApi } from '../services/catalogServiceAPI/avatarItemsProxy';

// One list for every select in the form (a campaign may show several).
let itemsPromise = null;
const loadItems = () => {
    itemsPromise ??= avatarItemsApi.list().catch(() => { itemsPromise = null; return []; });
    return itemsPromise;
};

/** Picks avatar items to show or give in a campaign block; any item, not only challenge prizes. */
export function CampaignAvatarItemSelect({ value, onChange, multiple = false, maxCount }) {
    const [items, setItems] = useState([]);

    useEffect(() => {
        let mounted = true;
        loadItems().then((loaded) => { if (mounted) setItems(loaded); });
        return () => { mounted = false; };
    }, []);

    return (
        <Select
            allowClear
            mode={multiple ? 'multiple' : undefined}
            maxCount={multiple ? maxCount : undefined}
            placeholder={multiple ? 'Pick items' : 'None'}
            value={multiple ? (value ?? []) : (value ?? undefined)}
            onChange={(next) => onChange?.(multiple ? (next ?? []) : (next ?? null))}
            options={items.map((item) => ({ value: item.id, label: item.enabled ? item.name : `${item.name} (disabled)` }))}
            optionFilterProp="label"
            notFoundContent="No avatar items yet"
            style={{ width: '100%' }}
        />
    );
}
